module.exports = __webpack_public_path__ + "img/solution-yasuoji.e4c92ea3.jpg";